import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from 'react-query'
import { App, URLOpenListenerEvent } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

const AppUrlListener: React.FC = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  // Navigate to Play page and refresh data when app returns to foreground
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    const stateListener = App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) {
        navigate('/user/play')
        queryClient.invalidateQueries('auth')
      }
    })

    return () => {
      stateListener.then((listener) => listener.remove())
    }
  }, [navigate, queryClient])

  useEffect(() => {
    // Set up deep link listener
    const deepLinkListener = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      console.log('Deep link received:', event.url)

      try {
        // Handle both custom scheme and Universal Links/App Links
        let path = ''

        if (event.url.includes('app.lvbl.club')) {
          // Universal Link (https://app.lvbl.club/#/user/play/...)
          const urlObj = new URL(event.url)
          path = urlObj.hash ? urlObj.hash.substring(1) : urlObj.pathname
        } else if (event.url.includes('/#/')) {
          // Custom scheme with hash (com.lvbl://#/user/play/...)
          path = event.url.split('/#/').pop() || ''
        } else {
          // Handle other custom scheme formats
          const customSchemeRegex = /^[^:]+:\/\/(.*)$/
          const customSchemeMatch = customSchemeRegex.exec(event.url)
          if (customSchemeMatch) {
            path = customSchemeMatch[1]
          }
        }

        if (path) {
          // Ensure path starts with /
          if (!path.startsWith('/')) {
            path = '/' + path
          }
          console.log('Navigating to:', path)
          navigate(path)
        }
      } catch (error) {
        console.error('Error parsing deep link URL:', error)
        // Fallback to original logic
        const slug = event.url.split('/#/').pop()
        if (slug) {
          navigate(`/${slug}`)
        }
      }
    })

    // Cleanup listeners on unmount
    return () => {
      deepLinkListener.then((listener) => listener.remove())
    }
  }, [navigate])

  return null
}

export default AppUrlListener
